import { z } from 'zod';

export const partnerPurchaseOrderConfigurationSchema = z.object({
  displayed: z.boolean(),
  required: z.boolean(),
});

export type PartnerPurchaseOrderConfiguration = z.infer<
  typeof partnerPurchaseOrderConfigurationSchema
>;
